export default __webpack_public_path__ + "static/media/160.47d7441a.gif";